import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SmartImage from 'dpl/components/SmartImage';

export default function BreedOverviewSectionContent({
  subheader,
  photo,
  content
}) {
  return (
    <div className="BreedOverviewSectionContent row">
      <div className="col-12 col-md-6">
        <h5 className="mb4 mb0-md f4 f6-md fw-medium lh-normal">{subheader}</h5>
      </div>
      <div className="col-12 col-md-6">
        <div
          className={classnames('font-16-mobile f3-md pre-wrap', {
            'mb8-md mb10': photo
          })}
        >
          {content}
        </div>
        {photo && (
          <a href={photo.source_url} target="_blank" rel="noopener noreferrer">
            <div className="aspect-ratio aspect-ratio--6x4 relative">
              <div className="aspect-ratio--object">
                <SmartImage
                  Tag="div"
                  className="w-100 h-100 cover bg-center"
                  src={photo.photo_url}
                  loadingClass="bg-light-gray"
                  alt={photo?.alt_text}
                />
              </div>
            </div>
            {photo.source_name && (
              <div className="flex justify-end f2 br3 pt2 tr dark-silver">
                Img:
                <p className="ml1 underline">{photo.source_name}</p>
              </div>
            )}
          </a>
        )}
      </div>
    </div>
  );
}

BreedOverviewSectionContent.propTypes = {
  subheader: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  photo: PropTypes.shape({
    photo_url: PropTypes.string.isRequired,
    source_url: PropTypes.string,
    source_name: PropTypes.string,
    alt_text: PropTypes.string
  })
};

BreedOverviewSectionContent.defaultProps = {
  photo: null
};
